import React, { Component } from "react";
import _isEqual from "lodash/isEqual";

import {
  StyledTable,
  THEAD,
  THD,
  TBODY,
  TR,
  TD,
} from "../../../components/table/table";
import { DashboardTextBox } from "../components/DashboardTexBox";
import _cloneDeep from "lodash/cloneDeep";
import { green300, black200, black100, black700 } from "../../../theme/colors";
import { Button } from "../../../components/Button";
import ReactTooltip from "react-tooltip";
import { getDayOrNumberSuffix } from "../../../helpers/getDayOrNumbersuffix";
import { SelectFilter } from "../components/SelectFilter";
import { transform } from "lodash";
import { getRetailerRequests } from '../../../actions/creation/getRetailerEditScreen';
import { el } from "date-fns/locale";
import moment from "moment";
import {
  isRelativeDateValidation,
  getRelativeDateValidations,
  getRelativeDateRangeText,
  checkDateBetweenValidations,
} from "../../../utils/CommonFunction";
export default class SkuTableOutlet extends Component {
  state = {
    allQuestionsAndAnswers: [],
    selectedAnswers: {},
    newAnswers: [],
  };

  getDateMinMax = (validations) => {
    if (!validations) return { min: undefined, max: undefined, isRel: false };

    let parsed = validations;
    if (Array.isArray(validations)) {
      const v0 = validations[0];
      const v1 = validations[1];
      if (v0 && v1) {
        if (
          moment(v0, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601], true).isValid() &&
          moment(v1, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601], true).isValid()
        ) {
          const isV0AfterV1 = moment(v0).isAfter(moment(v1));
          parsed = {
            greater_than: isV0AfterV1 ? v1 : v0,
            lower_than: isV0AfterV1 ? v0 : v1,
          };
        } else {
          parsed = { greater_than: v0, lower_than: v1 };
        }
      } else {
        parsed = { greater_than: v0, lower_than: v1 };
      }
    }

    const isRel =
      isRelativeDateValidation(parsed.greater_than) ||
      isRelativeDateValidation(parsed.lower_than) ||
      parsed.before != null ||
      parsed.after != null;

    if (isRel) {
      const before = parsed.greater_than ?? parsed.before;
      const after = parsed.lower_than ?? parsed.after;
      const today = moment().startOf("day");
      const min =
        before != null && before !== ""
          ? moment(today).subtract(Number(before), "days").format("YYYY-MM-DD")
          : undefined;
      const max =
        after != null && after !== ""
          ? moment(today).add(Number(after), "days").format("YYYY-MM-DD")
          : undefined;
      return { min, max, isRel, before, after };
    }

    let min = parsed.greater_than || undefined;
    let max = parsed.lower_than || undefined;

    if (min && max && moment(min).isAfter(moment(max))) {
      const temp = min;
      min = max;
      max = temp;
    }

    return {
      min,
      max,
      isRel: false,
    };
  };

  validateDate = (value, validations) => {
    if (!value) return "";
    const dateBounds = this.getDateMinMax(validations);
    if (dateBounds.isRel) {
      if (!getRelativeDateValidations(value, dateBounds.before, dateBounds.after)) {
        return getRelativeDateRangeText(dateBounds.before, dateBounds.after);
      }
    } else {
      const valMoment = moment(value, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601]);
      if (!valMoment.isValid()) return "Invalid date";

      const minMoment = dateBounds.min ? moment(dateBounds.min) : null;
      const maxMoment = dateBounds.max ? moment(dateBounds.max) : null;

      if (minMoment && maxMoment) {
        if (valMoment.isBefore(minMoment, "day") || valMoment.isAfter(maxMoment, "day")) {
          return `Date should be between ${dateBounds.min} and ${dateBounds.max}`;
        }
      } else if (minMoment && valMoment.isBefore(minMoment, "day")) {
        return `Date should be on or after ${dateBounds.min}`;
      } else if (maxMoment && valMoment.isAfter(maxMoment, "day")) {
        return `Date should be on or before ${dateBounds.max}`;
      }
    }
    return "";
  };

  handleSingleEdit = (question_id, value) => {
    const { allQuestionsAndAnswers } = this.state;
    const updatedAnswers = { ...allQuestionsAndAnswers };
    if (updatedAnswers[question_id]) {
      updatedAnswers[question_id].single_input = value;
      updatedAnswers[question_id].is_edited = true;
    }
    this.setState({
      allQuestionsAndAnswers: updatedAnswers,
    });
  };

  componentDidMount() {
    const { outlet_group_details } = this.props;
    const allQuestionsAndAnswers = {};
    outlet_group_details.forEach((question) => {
      question.related_answers.forEach((answers) => {
        allQuestionsAndAnswers[answers.id] = answers;
        delete allQuestionsAndAnswers[answers.id].multiple_images_input;
        delete allQuestionsAndAnswers[answers.id].single_image_input;
      });
    });
    this.setState({
      allQuestionsAndAnswers,
    });
    this.checkPendingRetailers();
  }

  checkPendingRetailers = async () => {
    try {
      const { workflowobject } = this.props;
      const response = await getRetailerRequests(workflowobject);
      const hasPending = response.some(
        (req) => req.retailer_master_status === "pending"
      );
      this.setState({ hasPendingRequests: hasPending });
    } catch (error) {
    }
  };


  componentDidUpdate(prevProps, prevState) {
    const { outlet_group_details = [] } = this.props;

    if (prevProps.outlet_group_details !== outlet_group_details) {
      const allQuestionsAndAnswers = {};
      outlet_group_details.forEach((question) => {
        question.related_answers.forEach((answers) => {
          allQuestionsAndAnswers[answers.id] = answers;
          delete allQuestionsAndAnswers[answers.id].multiple_images_input;
          delete allQuestionsAndAnswers[answers.id].single_image_input;
        });
      });
      this.setState({
        allQuestionsAndAnswers,
      });
    }
  }

  handleSave = () => {
    const { allQuestionsAndAnswers, newAnswers } = this.state;
    const { on_save, sku_products = [], outlet_group_details = [] } = this.props;

    let dateErrors = {};
    let hasDateError = false;

    outlet_group_details.forEach((question) => {
      (question.related_answers || []).forEach((answer) => {
        const prod = sku_products.find((p) => p.id === answer.sku_product);
        if (answer.sku_product_type === "date" || prod?.type === "date") {
          const value = allQuestionsAndAnswers[answer.id]?.single_input || "";
          const error = this.validateDate(
            value,
            prod?.validations || answer?.validations || answer?.sku_product_validations
          );
          dateErrors[`dateError_${answer.id}`] = error;
          if (error) {
            hasDateError = true;
          }
        }
      });
    });

    newAnswers.forEach((ans) => {
      const prod = sku_products.find((p) => p.id === ans.sku_product);
      if (prod?.type === "date") {
        const value = ans.single_input || "";
        const error = this.validateDate(value, prod?.validations);
        const errorKey = `dateError_new_${ans.sku_product}_${ans.question}`;
        dateErrors[errorKey] = error;
        if (error) {
          hasDateError = true;
        }
      }
    });

    if (Object.keys(dateErrors).length > 0) {
      this.setState(dateErrors);
    }

    if (hasDateError) {
      return;
    }

    const createdAnswers = [...newAnswers];

    const convertedCreatedAnswer = createdAnswers.map(item => ({
      ...item,
      multiple_answers_input: Array.isArray(item.multiple_answers_input)
        ? item.multiple_answers_input.map(ans =>
          typeof ans === "object" ? ans.value : ans
        )
        : []
    }));



    const updatedAnswers = Object.keys(allQuestionsAndAnswers).reduce(
      (acc, key) => {
        const answer = allQuestionsAndAnswers[key];
        if (answer?.is_edited) {
          acc[key] = answer;
        }
        return acc;
      },
      {}
    );

    const hasEdits =
      createdAnswers.length > 0 || Object.keys(updatedAnswers).length > 0;

    // ✅ Strictly send only one non-null payload
    const skuRequestBody = {
      object_type: "answers",
      data_to_create: convertedCreatedAnswer.length > 0 ? convertedCreatedAnswer : null,
      data_to_update: Object.keys(updatedAnswers).length > 0 ? updatedAnswers : null,
    };

    on_save(skuRequestBody);

    if (hasEdits) {
      const mergedAnswers = { ...allQuestionsAndAnswers };
      createdAnswers.forEach((ans) => {
        const key = `${ans.sku_product}-${ans.question}`;
        mergedAnswers[key] = { ...ans };
      });

      // this.setState({
      //   allQuestionsAndAnswers: mergedAnswers,
      //   newAnswers: [],
      // });
      this.setState({
        allQuestionsAndAnswers: mergedAnswers,
      });
    }
  };

  handleMultipleEdit = (question_id, selectedOptions) => {
    const { allQuestionsAndAnswers, selectedAnswers } = this.state;
    const updatedSelectedAnswers = {
      ...selectedAnswers,
      [question_id]: (selectedOptions || []).map((option) => option.label),
    };
    const updatedAnswers = { ...allQuestionsAndAnswers };
    if (updatedAnswers[question_id]) {
      updatedAnswers[question_id].multiple_answers_input = (
        selectedOptions || []
      ).map((option) => option.value);
      updatedAnswers[question_id].is_edited = true;
    }

    this.setState((prevState) => ({
      allQuestionsAndAnswers: Object.keys(updatedAnswers).length > 0
        ? updatedAnswers
        : prevState.allQuestionsAndAnswers,
    }));

  };

  handleSingleChoice = (question_id, selectedOptions) => {
    const optionsArr = Array.isArray(selectedOptions) ? selectedOptions : selectedOptions ? [selectedOptions] : [];
    const lastSelected = optionsArr.length > 0 ? optionsArr[optionsArr.length - 1] : null;
    const val = lastSelected ? (lastSelected.value !== undefined ? lastSelected.value : lastSelected) : "";

    const { allQuestionsAndAnswers } = this.state;
    const updatedAnswers = { ...allQuestionsAndAnswers };
    if (updatedAnswers[question_id]) {
      updatedAnswers[question_id].single_input = val;
      updatedAnswers[question_id].is_edited = true;
    }

    this.setState((prevState) => ({
      allQuestionsAndAnswers: Object.keys(updatedAnswers).length > 0
        ? updatedAnswers
        : prevState.allQuestionsAndAnswers,
    }));

  };

  render() {
    const {
      sku_products = [],
      outlet_group_details = [],
      disabled,
      requestInProcess,
    } = this.props;
    const { allQuestionsAndAnswers, selectedAnswers } = this.state;


    return (
      <div style={{ width: "100%", minWidth: 0, display: "flex", flexDirection: "column" }}>
        <StyledTable
          style={{
            paddingLeft: 0,
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "650px",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05)",
          }}
        >
          <THEAD>
            <THD
              width="220px"
              style={{
                position: "sticky",
                left: 0,
                zIndex: 10,
                background: "white",
                minWidth: "220px",
                width: "220px",
                maxWidth: "220px",
                borderRight: "1px solid #e2e8f0",
                boxShadow: "2px 0 5px rgba(0,0,0,0.04)",
                padding: "12px 16px",
                fontWeight: 600,
                color: "#1e293b",
                whiteSpace: "normal",
              }}
            >
              Question
            </THD>
            {sku_products.map((product) => (
              <THD
                key={product.id}
                width="240px"
                style={{
                  minWidth: "240px",
                  width: "240px",
                  maxWidth: "240px",
                  padding: "12px 14px",
                  fontWeight: 600,
                  color: "#1e293b",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {product.name
                  .toLowerCase()
                  .split(" ")
                  .map((x) => x[0]?.toUpperCase() + x.slice(1))
                  .join(" ")}
              </THD>
            ))}
          </THEAD>
          <TBODY>
            {outlet_group_details.map((question, upperIndex) => {

              const { related_answers = [] } = question;
              return (
                <TR
                  key={question.id}
                  style={{
                    height: "auto",
                    minHeight: "60px",
                    display: "inline-flex",
                    minWidth: "100%",
                    alignItems: "stretch",
                    borderBottom: "1px solid #e2e8f0",
                  }}
                  noBorder
                >
                  <TD
                    width="220px"
                    style={{
                      height: "auto",
                      minHeight: "60px",
                      minWidth: "220px",
                      width: "220px",
                      maxWidth: "220px",
                      padding: "12px 16px",
                      position: "sticky",
                      left: 0,
                      zIndex: 2,
                      background: "white",
                      borderRight: "1px solid #e2e8f0",
                      borderBottom: "none",
                      boxShadow: "2px 0 5px rgba(0,0,0,0.04)",
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      fontSize: "14px",
                      color: "#1e293b",
                      fontWeight: 500,
                    }}
                  >
                    {question.name}
                  </TD>
                  {sku_products.map((product) => {
                    let isDone = false;


                    const cells = related_answers.map((answer, index) => {
                      if (answer.sku_product === product.id) {
                        isDone = true;

                        const previous_answers = answer.previous_answers || {};
                        const actual_answer =
                          allQuestionsAndAnswers[answer.id]?.single_input || "";
                        const multipleDetails = [];


                        if (answer.sku_product_type === "multiple_choice" ||
                          answer.sku_product_type === "yes_or_no" ||
                          answer.sku_product_type === "single_choice" ||
                          answer.sku_product_type === "dropdown"
                        ) {
                          const validationCondition = Array.isArray(
                            answer.sku_product_validations
                          )
                            ? answer.sku_product_validations.join(";")
                            : answer.sku_product_validations || "";

                          validationCondition.split(";").forEach((item) => {
                            multipleDetails.push({ label: item, value: item });
                          });
                        }

                        let mappedValues = []
                        // selectedAnswers[answer.id] ||
                        //   (answer.multiple_answers_input || []).map((id) => {
                        //     const option = multipleDetails.find(
                        //       (option) => option.value === id
                        //     );
                        //     return option ? option.label : id;
                        //   });

                        const isMultipleChoice = product.type === "multiple_choice" || answer.sku_product_type === "multiple_choice";

                        if (isMultipleChoice) {
                          if (selectedAnswers[answer.id]) {
                            mappedValues = selectedAnswers[answer.id];
                          } else {
                            mappedValues = (answer.multiple_answers_input || []).map((id) => {
                              const option = multipleDetails.find(
                                (option) => option.value.toLowerCase() === (typeof id === "object" ? id.value : id).toLowerCase()
                              );
                              return option || { label: id, value: id };
                            });
                          }
                        } else if (product.type === "yes_or_no" || product.type === "single_choice" || product.type === "dropdown" || answer.sku_product_type === "yes_or_no" || answer.sku_product_type === "single_choice" || answer.sku_product_type === "dropdown") {
                          const currentVal = allQuestionsAndAnswers[answer.id]?.single_input !== undefined
                            ? allQuestionsAndAnswers[answer.id]?.single_input
                            : answer?.single_input;
                          if (currentVal !== undefined && currentVal !== null && currentVal !== "") {
                            const option = multipleDetails.find(
                              (opt) => opt.value.toLowerCase() === String(currentVal).toLowerCase()
                            );
                            mappedValues = option || { label: currentVal, value: currentVal };
                          } else {
                            mappedValues = null;
                          }
                        }

                        return (
                          <TD
                            key={index}
                            width="240px"
                            data-tip
                            data-for={`${answer.sku_product}-tip-${index}-${upperIndex}`}
                            style={{
                              overflow: "visible",
                              border: "none",
                              borderBottom: "none",
                              height: "auto",
                              minHeight: "60px",
                              minWidth: "240px",
                              width: "240px",
                              maxWidth: "240px",
                              padding: "12px 14px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >

                            {product.type === "date" || answer.sku_product_type === "date" ? (
                              (() => {
                                const dateBounds = this.getDateMinMax(product?.validations || answer?.validations);
                                const error = this.state[`dateError_${answer.id}`];
                                return (
                                  <div style={{ display: "flex", flexDirection: "column", width: "100%", justifyContent: "center" }}>
                                    <input
                                      type="date"
                                      value={actual_answer}
                                      min={dateBounds.min}
                                      max={dateBounds.max}
                                      style={{
                                        width: "100%",
                                        maxWidth: "200px",
                                        height: "40px",
                                        fontSize: "14px",
                                        padding: "6px 10px",
                                        border: `1px solid ${error ? "#ef4444" : "#cbd5e1"}`,
                                        borderRadius: "6px",
                                        color: "#334155",
                                        backgroundColor: disabled ? "#f8fafc" : "#ffffff",
                                        outline: "none",
                                        boxSizing: "border-box",
                                        transition: "border-color 0.2s ease",
                                      }}
                                      disabled={disabled}
                                      onChange={(e) => {
                                        const dateValue = e.target.value;
                                        const error = this.validateDate(
                                          dateValue,
                                          product?.validations || answer?.validations
                                        );
                                        this.setState({ [`dateError_${answer.id}`]: error });
                                        this.handleSingleEdit(answer.id, dateValue);
                                      }}
                                    />
                                    {error && (
                                      <div
                                        style={{
                                          color: "#ef4444",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          lineHeight: "1.35",
                                          marginTop: "6px",
                                          maxWidth: "200px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error}
                                      </div>
                                    )}
                                  </div>
                                );
                              })()
                            ) : (isMultipleChoice || product.type === "yes_or_no" || product.type === "single_choice" || product.type === "dropdown" || answer.sku_product_type === "yes_or_no" || answer.sku_product_type === "single_choice" || answer.sku_product_type === "dropdown") ? (
                              <SelectFilter
                                height="40px"
                                borderRadius="8px"
                                rootProps={{ style: { width: "100%", minWidth: "190px" } }}
                                styleProps={{
                                  control: (provided) => ({
                                    ...provided,
                                    borderColor: "#cbd5e1",
                                    boxShadow: "none",
                                    minHeight: "40px",
                                    "&:hover": {
                                      borderColor: "#cbd5e1",
                                    },
                                  }),
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    padding: isMultipleChoice ? "2px 6px" : "2px 8px",
                                    maxHeight: isMultipleChoice ? "72px" : "auto",
                                    overflowY: isMultipleChoice ? "auto" : "visible",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    backgroundColor: "#f1f5f9",
                                    borderRadius: "4px",
                                    margin: "1px 2px",
                                  }),
                                  multiValueLabel: (provided) => ({
                                    ...provided,
                                    fontSize: "11px",
                                    fontWeight: 500,
                                    padding: "1px 4px",
                                    color: "#334155",
                                  }),
                                  multiValueRemove: (provided) => ({
                                    ...provided,
                                    color: "#94a3b8",
                                    padding: "0 2px",
                                    ":hover": {
                                      backgroundColor: "#e2e8f0",
                                      color: "#ef4444",
                                    },
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    borderRadius: "8px",
                                    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
                                  }),
                                }}
                                props={{
                                  value: mappedValues,
                                  options: multipleDetails,
                                  onChange: (selectedOptions) => {
                                    if (isMultipleChoice) {
                                      this.handleMultipleEdit(answer.id, selectedOptions);
                                    } else {
                                      this.handleSingleChoice(answer.id, selectedOptions);
                                    }
                                  },
                                  placeholderColor: black700,
                                  isMulti: isMultipleChoice,
                                  width: "100%",
                                  isDisabled: disabled,
                                }}
                                noOptionMessage="No data available"
                              />
                            ) : (
                              <DashboardTextBox
                                isSKU
                                isSearchBox={true}
                                boxWidth={"150px"}
                                boxHeight="40px"
                                type="text"
                                placeholder={`Enter ${answer.answer_type || "text"}`}
                                value={actual_answer}
                                disabled={disabled}
                                onChange={(e) => this.handleSingleEdit(answer.id, e.target.value)}
                              />
                            )}


                            {actual_answer && actual_answer.length > 10 && (
                              <ReactTooltip
                                id={`${answer.sku_product}-tip-${index}-${upperIndex}`}
                              >
                                {actual_answer}
                              </ReactTooltip>
                            )}

                            {Object.keys(previous_answers).length > 0 && (
                              <>
                                {/* <InfoIcon
                                  data-tip
                                  data-for={`tooltip-${answer.sku_product}`}
                                /> */}
                                <ReactTooltip
                                  id={`tooltip-${answer.sku_product}`}
                                  place={"bottom"}
                                  type={"dark"}
                                >
                                  {Object.keys(previous_answers).map((key) => (
                                    <div key={key}>
                                      {getDayOrNumberSuffix(key)} Prev:{" "}
                                      {previous_answers[key].single_input}
                                      <p>
                                        {previous_answers[key].sub_project_name}
                                      </p>
                                    </div>
                                  ))}
                                </ReactTooltip>
                              </>
                            )}
                          </TD>
                        );
                      }
                      return null;
                    });



                    if (!isDone) {
                      const existingNewAnswer = this.state.newAnswers.find(
                        (a) =>
                          a.sku_product === product.id &&
                          a.question === question.id
                      );
                      const fallbackValue =
                        existingNewAnswer?.single_input || "";

                      let mappedValues = []
                      const multipleChoiceOption = []
                      const a = product?.validations?.choices?.split(";").forEach((item) => {
                        multipleChoiceOption.push({ label: item, value: item });
                      });

                      const isNewMultipleChoice = product.type === "multiple_choice";

                      if (existingNewAnswer) {
                        if (isNewMultipleChoice) {
                          mappedValues =
                            existingNewAnswer?.multiple_answers_input?.map((id) => {
                              const val = typeof id === "object" ? id.value : id;
                              const option = multipleChoiceOption.find(
                                (opt) => opt.value.toLowerCase() === String(val).toLowerCase()
                              );
                              return option || { label: val, value: val };
                            }) || [];
                        } else if (product.type === "yes_or_no" || product.type === "single_choice" || product.type === "dropdown") {
                          if (existingNewAnswer?.single_input) {
                            const val = existingNewAnswer.single_input;
                            const matchedOpt = multipleChoiceOption.find(
                              (opt) => opt.value.toLowerCase() === String(val).toLowerCase()
                            );
                            mappedValues = matchedOpt || { label: val, value: val };
                          } else {
                            mappedValues = null;
                          }
                        }
                      } else {
                        mappedValues = isNewMultipleChoice ? [] : null;
                      }

                      cells.push(
                        <TD
                          key={`new-${product.id}-${question.id}`}
                          width="240px"
                          data-tip
                          data-for={`${product.id}-tip`}
                          style={{
                            overflow: "visible",
                            border: "none",
                            borderBottom: "none",
                            height: "auto",
                            minHeight: "60px",
                            minWidth: "240px",
                            width: "240px",
                            maxWidth: "240px",
                            padding: "12px 14px",
                            display: "flex",
                            alignItems: "center",
                          }}>
                          {product.type === "date" ? (
                            (() => {
                              const dateBounds = this.getDateMinMax(product?.validations);
                              const errorKey = `dateError_new_${product.id}_${question.id}`;
                              const error = this.state[errorKey];
                              return (
                                <div style={{ display: "flex", flexDirection: "column", width: "100%", justifyContent: "center" }}>
                                  <input
                                    type="date"
                                    value={fallbackValue}
                                    min={dateBounds.min}
                                    max={dateBounds.max}
                                    style={{
                                      width: "100%",
                                      maxWidth: "200px",
                                      height: "40px",
                                      fontSize: "14px",
                                      padding: "6px 10px",
                                      border: `1px solid ${error ? "#ef4444" : "#cbd5e1"}`,
                                      borderRadius: "6px",
                                      color: "#334155",
                                      backgroundColor: disabled ? "#f8fafc" : "#ffffff",
                                      outline: "none",
                                      boxSizing: "border-box",
                                      transition: "border-color 0.2s ease",
                                    }}
                                    disabled={disabled}
                                    onChange={(e) => {
                                      const dateValue = e.target.value;
                                      const error = this.validateDate(dateValue, product?.validations);
                                      this.setState({ [errorKey]: error });

                                      const newAnswers = [...this.state.newAnswers];
                                      const existingIndex = newAnswers.findIndex(
                                        (a) =>
                                          a.sku_product === product.id &&
                                          a.question === question.id
                                      );

                                      if (existingIndex > -1) {
                                        newAnswers[existingIndex].single_input = dateValue;
                                      } else {
                                        newAnswers.push({
                                          sku_product: product.id,
                                          question: question.id,
                                          workflow_object: this.props.workflowobject || null,
                                          single_input: dateValue,
                                          single_image_input: null,
                                          multiple_images_input: [],
                                          multiple_answers_input: [],
                                          verified: false,
                                          temp_index: 33922,
                                        });
                                      }
                                      this.setState({ newAnswers });
                                    }}
                                  />
                                  {error && (
                                    <div
                                      style={{
                                        color: "#ef4444",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        lineHeight: "1.35",
                                        marginTop: "6px",
                                        maxWidth: "200px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {error}
                                    </div>
                                  )}
                                </div>
                              );
                            })()
                          ) : (product.type === "multiple_choice" || product.type === "yes_or_no" || product.type === "single_choice" || product.type === "dropdown") ? (
                            <SelectFilter
                              height="40px"
                              borderRadius="8px"
                              rootProps={{ style: { width: "100%", minWidth: "190px" } }}
                              styleProps={{
                                control: (provided) => ({
                                  ...provided,
                                  borderColor: "#cbd5e1",
                                  boxShadow: "none",
                                  minHeight: "40px",
                                  "&:hover": {
                                    borderColor: "#cbd5e1",
                                  },
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: isNewMultipleChoice ? "2px 6px" : "2px 8px",
                                  maxHeight: isNewMultipleChoice ? "72px" : "auto",
                                  overflowY: isNewMultipleChoice ? "auto" : "visible",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  backgroundColor: "#f1f5f9",
                                  borderRadius: "4px",
                                  margin: "1px 2px",
                                }),
                                multiValueLabel: (provided) => ({
                                  ...provided,
                                  fontSize: "11px",
                                  fontWeight: 500,
                                  padding: "1px 4px",
                                  color: "#334155",
                                }),
                                multiValueRemove: (provided) => ({
                                  ...provided,
                                  color: "#94a3b8",
                                  padding: "0 2px",
                                  ":hover": {
                                    backgroundColor: "#e2e8f0",
                                    color: "#ef4444",
                                  },
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  borderRadius: "8px",
                                  boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
                                }),
                              }}
                              props={{
                                value: mappedValues,
                                options: multipleChoiceOption,
                                fieldName: isNewMultipleChoice ? "multiple_answers_input" : "single_input",
                                onChange: ((selectedOptions) => {
                                  const newAnswers = [...this.state.newAnswers];

                                  const existingIndex = newAnswers.findIndex(
                                    (a) =>
                                      a.sku_product === product.id &&
                                      a.question === question.id
                                  );

                                  const isSingle = !isNewMultipleChoice;
                                  let answerVal = "";
                                  if (isSingle) {
                                    const opt = Array.isArray(selectedOptions) ? selectedOptions[0] : selectedOptions;
                                    answerVal = opt ? (opt.value !== undefined ? opt.value : opt) : "";
                                  }

                                  if (existingIndex > -1) {
                                    if (isSingle) {
                                      newAnswers[existingIndex].single_input = answerVal;
                                    } else {
                                      let answer = selectedOptions != null ? [...selectedOptions] : [];
                                      newAnswers[existingIndex].multiple_answers_input = answer;
                                    }
                                  } else {
                                    if (isSingle) {
                                      newAnswers.push({
                                        sku_product: product.id,
                                        question: question.id,
                                        workflow_object: this.props.workflowobject || null,
                                        single_input: answerVal,
                                        single_image_input: null,
                                        multiple_images_input: [],
                                        multiple_answers_input: [],
                                        verified: false,
                                        temp_index: 33922,
                                      });
                                    } else {
                                      newAnswers.push({
                                        sku_product: product.id,
                                        question: question.id,
                                        workflow_object: this.props.workflowobject || null,
                                        single_input: null,
                                        single_image_input: null,
                                        multiple_images_input: [],
                                        multiple_answers_input: selectedOptions || [],
                                        verified: false,
                                        temp_index: 33922,
                                      });
                                    }
                                  }
                                  this.setState({ newAnswers });
                                }),
                                placeholderColor: black700,
                                isMulti: isNewMultipleChoice,
                                width: "100%",
                                isDisabled: disabled,
                              }}
                              noOptionMessage="No data available"
                            />
                          ) : (
                            <DashboardTextBox
                              isSKU
                              isSearchBox={true}
                              boxWidth={"150px"}
                              boxHeight="40px"
                              type="text"
                              placeholder={`Enter answer`}
                              disabled={disabled}
                              value={fallbackValue}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                const newAnswers = [...this.state.newAnswers];
                                const existingIndex = newAnswers.findIndex(
                                  (a) =>
                                    a.sku_product === product.id &&
                                    a.question === question.id
                                );
                                if (existingIndex > -1) {
                                  newAnswers[existingIndex].single_input = newValue;
                                } else {
                                  newAnswers.push({
                                    sku_product: product.id,
                                    question: question.id,
                                    workflow_object: this.props.workflowobject || null,
                                    single_input: newValue,
                                    single_image_input: null,
                                    multiple_images_input: [],
                                    verified: false,
                                    temp_index: 33922,
                                  });
                                }
                                this.setState({ newAnswers });
                              }}
                            />)}
                          {/* </div> */}
                        </TD>
                      );
                    }

                    return cells;
                  })}
                </TR>
              );
            })}
          </TBODY>
        </StyledTable>

        {!disabled &&
          (this.state.hasPendingRequests ? (
            <p
              style={{ color: "red", fontWeight: "bold", marginTop: "16px" }}
            >
              Please complete all pending retailer edits before proceeding.
            </p>
          ) : (
            <div style={{ marginTop: "20px", display: "flex", alignItems: "center" }}>
              <Button
                size="medium"
                type="submit"
                bgColor={green300}
                isLoading={requestInProcess}
                onClick={this.handleSave}
              >
                Save and Next
              </Button>
            </div>
          ))}
      </div>
    );
  }
}
